// @ts-expect-error untyped module
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error untyped module
import ActivityTypeReferenceResolver from 'reference-resolvers/resolvers/ActivityTypeReferenceResolver';
// @ts-expect-error untyped module
import AdsAdgroupsReferenceResolver from 'reference-resolvers/resolvers/AdsAdgroupsReferenceResolver';
// @ts-expect-error untyped module
import AdsCampaignsReferenceResolver from 'reference-resolvers/resolvers/AdsCampaignsReferenceResolver';
// @ts-expect-error untyped module
import AdsAdsReferenceResolver from 'reference-resolvers/resolvers/AdsAdsReferenceResolver';
// @ts-expect-error untyped module reference-resolvers
import BusinessUnitReferenceResolver from 'reference-resolvers/resolvers/BusinessUnitReferenceResolver';
// @ts-expect-error untyped module
import AllObjectPropertiesReferenceResolver from 'reference-resolvers/resolvers/AllObjectPropertiesReferenceResolver';
// @ts-expect-error untyped module
import AutomatedEmailReferenceResolver from 'reference-resolvers/resolvers/AutomatedEmailReferenceResolver';
import AutomationPlatformWorkflowResolver, { createAutomationPlatformWorkflowReferenceResolver
// @ts-expect-error untyped module
} from 'reference-resolvers/resolvers/AutomationPlatformWorkflowReferenceResolver';
// @ts-expect-error untyped module
import CallDispositionReferenceResolver from 'reference-resolvers/resolvers/CallDispositionReferenceResolver';
// @ts-expect-error untyped module
import ChatflowsReferenceResolver from 'reference-resolvers/resolvers/ChatflowsReferenceResolver';
// @ts-expect-error untyped module
import ChatflowByUniqueIdReferenceResolver from 'reference-resolvers/resolvers/ChatflowByUniqueIdReferenceResolver';
// @ts-expect-error untyped module
import CompanyPropertyReferenceResolver from 'reference-resolvers/resolvers/CompanyPropertyReferenceResolver';
// @ts-expect-error untyped module
import CompanyReferenceResolver from 'reference-resolvers/resolvers/CompanyReferenceResolver';
// @ts-expect-error untyped module
import ContactListReferenceResolver from 'reference-resolvers/resolvers/ContactListReferenceResolver';
// @ts-expect-error untyped module
import ContactPropertyReferenceResolver from 'reference-resolvers/resolvers/ContactPropertyReferenceResolver';
// @ts-expect-error untyped module
import ContactReferenceResolver from 'reference-resolvers/resolvers/ContactReferenceResolver';
// @ts-expect-error untyped module
import ContactStaticListReferenceResolver from 'reference-resolvers/resolvers/ContactStaticListReferenceResolver';
// @ts-expect-error untyped module
import ConversationInboxReferenceResolver from 'reference-resolvers/resolvers/ConversationInboxReferenceResolver';
// @ts-expect-error untyped module
import CustomObjectReferenceResolver from 'reference-resolvers/resolvers/CustomObjectReferenceResolver';
// @ts-expect-error untyped module
import CustomObjectTypeReferenceResolver from 'reference-resolvers/resolvers/CustomObjectTypeReferenceResolver';
import CTAGuidReferenceResolver from 'reference-resolvers/resolvers/CTAGuidReferenceResolver';
// @ts-expect-error untyped module
import ObjectPropertiesReferenceResolver from 'reference-resolvers/resolvers/ObjectPropertiesReferenceResolver';
// @ts-expect-error untyped module
import DealPropertyReferenceResolver from 'reference-resolvers/resolvers/DealPropertyReferenceResolver';
// @ts-expect-error untyped module
import DealReferenceResolver from 'reference-resolvers/resolvers/DealReferenceResolver';
// @ts-expect-error untyped module
import EmailReferenceResolver from 'reference-resolvers/resolvers/EmailReferenceResolver';
import { createEmailCampaignReferenceResolver
// @ts-expect-error untyped module
} from 'reference-resolvers/resolvers/EmailCampaignReferenceResolver';
// @ts-expect-error untyped module
import EngagementPropertyReferenceResolver from 'reference-resolvers/resolvers/EngagementPropertyReferenceResolver';
// @ts-expect-error untyped module
import FormBatchedReferenceResolver from 'reference-resolvers/resolvers/FormBatchedReferenceResolver';
// @ts-expect-error untyped module
import HierarchicalTeamReferenceResolver from 'reference-resolvers/resolvers/HierarchicalTeamReferenceResolver';
// @ts-expect-error untyped module
import InboundDbListsReferenceResolver from 'reference-resolvers/resolvers/InboundDbListsReferenceResolver';
// @ts-expect-error untyped module
import IntegrationNameReferenceResolver from 'reference-resolvers/resolvers/IntegrationNameReferenceResolver';
// @ts-expect-error untyped module
import InvoicePropertyReferenceResolver from 'reference-resolvers/resolvers/InvoicePropertyReferenceResolver';
// @ts-expect-error untyped module
import LineItemPropertyReferenceResolver from 'reference-resolvers/resolvers/LineItemPropertyReferenceResolver';
// @ts-expect-error untyped module
import LineItemReferenceResolver from 'reference-resolvers/resolvers/LineItemReferenceResolver';
// @ts-expect-error untyped module
import MultiCurrencyCurrencyCodeResolver from 'reference-resolvers/resolvers/MultiCurrencyCurrencyCodeResolver';
// @ts-expect-error untyped module
import MultiCurrencyInformationResolver from 'reference-resolvers/resolvers/MultiCurrencyInformationResolver';
// @ts-expect-error untyped module
import OwnerPagedReferenceResolver from 'reference-resolvers/resolvers/OwnerPagedReferenceResolver';
// @ts-expect-error untyped module
import PersonaReferenceResolver from 'reference-resolvers/resolvers/PersonaReferenceResolver';
// @ts-expect-error untyped module
import PipelineReferenceResolver from 'reference-resolvers/resolvers/PipelineReferenceResolver';
// @ts-expect-error untyped module
import PipelineStageReferenceResolver from 'reference-resolvers/resolvers/PipelineStageReferenceResolver';
// @ts-expect-error untyped module
import QuotePropertyReferenceResolver from 'reference-resolvers/resolvers/QuotePropertyReferenceResolver';
// @ts-expect-error untyped module
import QuoteReferenceResolver from 'reference-resolvers/resolvers/QuoteReferenceResolver';
// @ts-expect-error untyped module
import { createSalesforceCampaignReferenceResolver } from 'reference-resolvers/resolvers/SalesforceCampaignReferenceResolver';
// @ts-expect-error untyped module
import SiteContentReferenceResolver from 'reference-resolvers/resolvers/SiteContentReferenceResolver';
// @ts-expect-error untyped module
import SharedTaskQueuesReferenceResolver from 'reference-resolvers/resolvers/SharedTaskQueuesReferenceResolver';
// @ts-expect-error untyped module
import SlackChannelReferenceResolver from 'reference-resolvers/resolvers/SlackChannelReferenceResolver';
// @ts-expect-error untyped module
import SlackUserReferenceResolver from 'reference-resolvers/resolvers/SlackUserReferenceResolver';
// @ts-expect-error untyped module
import TicketPipelinesReferenceResolver from 'reference-resolvers/resolvers/TicketPipelinesReferenceResolver';
// @ts-expect-error untyped module
import TicketPropertyReferenceResolver from 'reference-resolvers/resolvers/TicketPropertyReferenceResolver';
// @ts-expect-error untyped module
import TicketReferenceResolver from 'reference-resolvers/resolvers/TicketReferenceResolver';
// @ts-expect-error untyped module
import TicketStagesReferenceResolver from 'reference-resolvers/resolvers/TicketStagesReferenceResolver';
// @ts-expect-error untyped module
import UserReferenceResolver from 'reference-resolvers/resolvers/UserReferenceResolver';
import WebInteractiveReferenceResolver from 'reference-resolvers/resolvers/WebInteractiveReferenceResolver';

// @ts-expect-error untyped module
import WorkflowReferenceResolver from 'reference-resolvers/resolvers/WorkflowReferenceResolver';
// @ts-expect-error untyped module
import WorkflowFolderReferenceResolver from 'reference-resolvers/resolvers/WorkflowFolderReferenceResolver';

// Workflows handrolled resolvers
import { AssignableUserResolver, LegaciedAssignableUserResolver } from 'automation-ui-action-features/users-and-teams/AssignableUserResolver';
import { ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES } from 'automation-ui-canvas/reference-resolvers/types';
const typeToResolverMap = {
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.ACTIVITY_TYPE]: ActivityTypeReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.AD_OBJECT_AD_CAMPAIGN]: AdsCampaignsReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.AD_OBJECT_AD_GROUP]: AdsAdgroupsReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.AD_OBJECT_AD]: AdsAdsReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.AUTOMATION_PLATFORM_WORKFLOWS]: AutomationPlatformWorkflowResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.ASSIGNABLE_USER]: AssignableUserResolver,
  // from WorkflowsReactUI
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.BUSINESS_UNIT]: BusinessUnitReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CALL_DISPOSITION]: CallDispositionReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CHATFLOW]: ChatflowsReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CHATFLOW_BY_UNIQUE_ID]: ChatflowByUniqueIdReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.COMPANY_PROPERTY]: CompanyPropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.COMPANY]: CompanyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CONTACT_LIST]: ContactListReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CONTACT_PROPERTY]: ContactPropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CONTACT_STATIC_LIST]: ContactStaticListReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CONTACT]: ContactReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CONVERSATION_INBOX]: ConversationInboxReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CUSTOM_OBJECT_TYPE]: CustomObjectTypeReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CTA_GUID]: CTAGuidReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.DEAL]: DealReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.DEAL_PIPELINE_STAGE]: PipelineStageReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.DEAL_PIPELINE]: PipelineReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.DEAL_PROPERTY]: DealPropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.EMAIL]: EmailReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.ENGAGEMENT_PROPERTY]: EngagementPropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.FORM]: FormBatchedReferenceResolver,
  // used by EnrollmentFilter, FormName
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.HIERARCHICAL_TEAM]: HierarchicalTeamReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.INBOUND_DB_LISTS]: InboundDbListsReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.INTEGRATION_NAME]: IntegrationNameReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.INVOICE_PROPERTY]: InvoicePropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.LEGACIED_ASSIGNABLE_USER]: LegaciedAssignableUserResolver,
  // from WorkflowsReactUI
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.LINE_ITEM]: LineItemReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.LINE_ITEM_PROPERTY]: LineItemPropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.MULTI_CURRENCY_CURRENCY_CODE]: MultiCurrencyCurrencyCodeResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.MULTI_CURRENCY_INFORMATION]: MultiCurrencyInformationResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.OWNER]: OwnerPagedReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.PERSONA]: PersonaReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.QUOTE]: QuoteReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.QUOTE_PROPERTY]: QuotePropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.SALESFORCE_CAMPAIGN]: createSalesforceCampaignReferenceResolver({
    idIsValid: id => !!id
  }),
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.SITE_CONTENT]: SiteContentReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.TEAM]: HierarchicalTeamReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.TICKET]: TicketReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.TICKET_PIPELINE]: TicketPipelinesReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.TICKET_PROPERTY]: TicketPropertyReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.TICKET_STAGE]: TicketStagesReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.USER]: UserReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.WEB_INTERACTIVE]: WebInteractiveReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.WORKFLOW]: WorkflowReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.WORKFLOW_FOLDER]: WorkflowFolderReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.SLACK_CHANNEL]: SlackChannelReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.SLACK_USER]: SlackUserReferenceResolver,
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.SHARED_TASK_QUEUE]: SharedTaskQueuesReferenceResolver,
  // special cased for these resolvers since they require
  // extra arguments for instantiation
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.AUTOMATED_EMAIL]: resolversCache => () => ({
    resolversCache,
    resolverFactory: AutomatedEmailReferenceResolver
  }),
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.ALL_OBJECT_PROPERTIES]: resolversCache => () => ({
    resolversCache,
    resolverFactory: AllObjectPropertiesReferenceResolver
  }),
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CUSTOM_OBJECT]: resolversCache => () => ({
    resolversCache,
    resolverFactory: CustomObjectReferenceResolver
  }),
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.OBJECT_PROPERTIES]: resolversCache => () => ({
    resolversCache,
    resolverFactory: ObjectPropertiesReferenceResolver
  }),
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.AUTOMATION_PLATFORM_WORKFLOWS_BY_OBJECT_TYPE_ID]: resolversCache => () => ({
    resolversCache,
    resolverFactory: createAutomationPlatformWorkflowReferenceResolver
  }),
  [ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.EMAIL_CAMPAIGN_BY_ID_LEVEL]: resolversCache => () => ({
    resolversCache,
    resolverFactory: createEmailCampaignReferenceResolver
  })
};
const provideAllSupportedResolvers = ProvideReferenceResolvers(typeToResolverMap);
export default provideAllSupportedResolvers;